import { Link, useParams } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import StudentModals from "../studentModals";
import StudentSidebar from "./studentSidebar";
import StudentBreadcrumb from "./studentBreadcrumb";
import { useGetStudentByIdQuery } from "../api/studentApi";
import { API_CONFIG } from "../../../../core/config";

const StudentDetails = () => {
  const routes = all_routes;
  const { id } = useParams<{ id: string }>();
  const {
    data: studentResponse,
    isLoading,
    error,
  } = useGetStudentByIdQuery({ id: id || "" });
  const student = studentResponse?.data?.student;
  const studentStatus = student?.status;

  if (isLoading) {
    return (
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <StudentBreadcrumb studentId={id} />
          </div>
          <div className="row">
            <StudentSidebar />
            <div className="col-xxl-9 col-xl-8">
              <div className="row">
                <div className="col-md-12">
                  <ul className="nav nav-tabs nav-tabs-bottom mb-4">
                    <li>
                      <Link
                        to={`${routes.studentDetail.replace(":id", id || "")}`}
                        className="nav-link active"
                      >
                        <i className="ti ti-school me-2" />
                        Student Details
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`${routes.studentAttendanceDetail.replace(
                          ":id",
                          id || ""
                        )}`}
                        className="nav-link"
                      >
                        <i className="ti ti-calendar-due me-2" />
                        Attendance
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`${routes.studentFees.replace(":id", id || "")}`}
                        className="nav-link"
                      >
                        <i className="ti ti-report-money me-2" />
                        Fees
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`${routes.studentResult.replace(":id", id || "")}`}
                        className="nav-link"
                      >
                        <i className="ti ti-bookmark-edit me-2" />
                        Results
                      </Link>
                    </li>
                  </ul>

                  <div className="card">
                    <div className="card-body p-0 py-3">
                      <div className="text-center">
                        Loading student details...
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return <div>Error loading student data</div>;
  }

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            {/* Page Header */}
            <StudentBreadcrumb studentId={id} studentStatus={studentStatus} />
            {/* /Page Header */}
          </div>
          <div className="row">
            {/* Student Information */}
            <StudentSidebar />
            {/* /Student Information */}
            <div className="col-xxl-9 col-xl-8">
              <div className="row">
                <div className="col-md-12">
                  {/* List */}
                  <ul className="nav nav-tabs nav-tabs-bottom mb-4">
                    <li>
                      <Link
                        to={`${routes.studentDetail.replace(":id", id || "")}`}
                        className="nav-link active"
                      >
                        <i className="ti ti-school me-2" />
                        Student Details
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`${routes.studentAttendanceDetail.replace(
                          ":id",
                          id || ""
                        )}`}
                        className="nav-link"
                      >
                        <i className="ti ti-calendar-due me-2" />
                        Attendance
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`${routes.studentFees.replace(":id", id || "")}`}
                        className="nav-link"
                      >
                        <i className="ti ti-report-money me-2" />
                        Fees
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`${routes.studentResult.replace(":id", id || "")}`}
                        className="nav-link"
                      >
                        <i className="ti ti-bookmark-edit me-2" />
                        Results
                      </Link>
                    </li>
                  </ul>
                </div>

                {/* Address */}
                <div className="col-xxl-12 d-flex">
                  <div className="card flex-fill w-100">
                    <div className="card-header">
                      <h5>Address</h5>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="d-flex align-items-center mb-3">
                            <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                              <i className="ti ti-map-pin-up" />
                            </span>
                            <div>
                              <p className="text-dark fw-medium mb-1">
                                Current Address
                              </p>
                              <p>
                                {student?.address?.address ? `${student.address.address}, ` : ""}
                                {student?.address?.district}
                                <br />
                                {student?.address?.state} {" "}
                                {student?.address?.pincode ? "-" : ""}{" "}
                                {student?.address?.pincode || ""}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="d-flex align-items-center mb-3">
                            <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                              <i className="ti ti-map-pins" />
                            </span>
                            <div>
                              <p className="text-dark fw-medium mb-1">
                                Permanent Address
                              </p>
                              <p>
                                {student?.address?.address ? `${student.address.address}, ` : ""}
                                {student?.address?.district}
                                <br />
                                {student?.address?.state} {" "}
                                {student?.address?.pincode ? "-" : ""}{" "}
                                {student?.address?.pincode || ""}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Address */}
                {/* School Details */}
                <div className="col-xxl-12">
                  <div className="card">
                    <div className="card-header">
                      <h5>School Details</h5>
                    </div>
                    <div className="card-body pb-1">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">
                              School Name
                            </p>
                            <p>{student?.profile?.institution_name || "N/A"}</p>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <p className="text-dark fw-medium mb-1">Class</p>
                            <p>{student?.profile?.class || "N/A"}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Previous School Details */}

                {/* Documents Section */}
                <div className="col-xxl-12">
                  <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between">
                      <h5>Documents</h5>
                      {(studentStatus === "active" || studentStatus === "pending") && (
                        <Link
                          to={`${routes.studentDocuments.replace(
                            ":id",
                            id || ""
                          )}`}
                          className="btn btn-primary btn-sm"
                        >
                          <i className="ti ti-plus me-1"></i>Upload Documents
                        </Link>
                      )}
                    </div>
                    <div className="card-body">
                      <div className="row g-3">
                        {/* Birth Certificate */}
                        <div className="col-sm-6 col-md-4 col-xl-3">
                          <div className="card border shadow-none h-100">
                            <div className="card-body d-flex flex-column">
                              <div className="document-download">
                                <i className="ti ti-file-certificate fs-1 text-primary"></i>
                              </div>
                              <div className="mt-3">
                                <h6 className="mb-1">Birth Certificate</h6>
                                <p className="fs-13 text-muted mb-2">
                                  {student?.docs?.dob
                                    ? "Uploaded"
                                    : "Not uploaded"}
                                </p>
                                {student?.docs?.dob && (
                                  <a
                                    href={`${API_CONFIG.BASE_URL}students/download-dob/${student.docs.dob}`}
                                    className="text-primary d-flex align-items-center"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <i className="ti ti-download me-1"></i>
                                    Download
                                  </a>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Class Proof */}
                        <div className="col-sm-6 col-md-4 col-xl-3">
                          <div className="card border shadow-none h-100">
                            <div className="card-body d-flex flex-column">
                              <div className="document-download">
                                <i className="ti ti-file-certificate fs-1 text-primary"></i>
                              </div>
                              <div className="mt-3">
                                <h6 className="mb-1">Class Proof</h6>
                                <p className="fs-13 text-muted mb-2">
                                  {student?.docs?.class_proof
                                    ? "Uploaded"
                                    : "Not uploaded"}
                                </p>
                                {student?.docs?.class_proof && (
                                  <a
                                    href={`${API_CONFIG.BASE_URL}students/download-class-proof/${student.docs.class_proof}`}
                                    className="text-primary d-flex align-items-center"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <i className="ti ti-download me-1"></i>
                                    Download
                                  </a>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Documents Section */}

                {/* Certificates Section */}
                <div className="col-xxl-12">
                  <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between">
                      <h5>Certificates</h5>
                    </div>
                    <div className="card-body">
                      <div className="row g-3">
                        {student?.course?.stage_certificates && student.course.stage_certificates.length > 0 ? (
                          student.course.stage_certificates.map((cert) => (
                            <div className="col-sm-6 col-md-4 col-xl-3" key={cert.stage_id}>
                              <div className="card border shadow-none mb-0 overflow-hidden">
                                {/* Thumbnail Container */}
                                <div className="bg-light border-bottom position-relative" style={{ height: "130px", overflow: "hidden", marginLeft: "-5px", marginTop: "-5px" }}>
                                  {cert.certificate_name ? (
                                    <iframe
                                      src={`${API_CONFIG.BASE_URL}certificates/download/${cert.certificate_name}?contentDisposition=inline#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
                                      title={`${cert.stage_name} Certificate`}
                                      style={{
                                        width: "calc(100% + 18px)",
                                        height: "calc(100% + 18px)",
                                        border: "none",
                                        pointerEvents: "none"
                                      }}
                                      scrolling="no"
                                    />
                                  ) : (
                                    <div className="d-flex align-items-center justify-content-center h-100">
                                      <div className="text-center text-muted">
                                        <i className="ti ti-award fs-1"></i>
                                        <p className="fs-12 mb-0 mt-1">Not Issued</p>
                                      </div>
                                    </div>
                                  )}
                                </div>

                                {/* Footer */}
                                <div className="card-body py-2 px-3 d-flex flex-column">
                                  <div className="mb-2 overflow-hidden">
                                    <h6 className="mb-0 text-truncate fs-14">{cert.stage_name}</h6>
                                    <span className="fs-12 text-muted">
                                      {cert.certificate_name ? "Issued" : "Not Issued"}
                                    </span>
                                  </div>
                                  {cert.certificate_name ? (
                                    <div className="d-flex align-items-center justify-content-between">
                                      <a
                                        href={`${API_CONFIG.BASE_URL}certificates/download/${cert.certificate_name}?contentDisposition=inline`}
                                        className="text-primary d-flex align-items-center fs-13 fw-medium"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <i className="ti ti-eye me-1"></i>View
                                      </a>
                                      <a
                                        href={`${API_CONFIG.BASE_URL}certificates/download/${cert.certificate_name}?contentDisposition=attachment`}
                                        className="text-success d-flex align-items-center fs-13 fw-medium"
                                      >
                                        <i className="ti ti-download me-1"></i>Download
                                      </a>
                                    </div>
                                  ) : (
                                    <div className="d-flex align-items-center justify-content-between">
                                      <span className="text-muted d-flex align-items-center fs-13 fw-medium disabled">
                                        <i className="ti ti-lock me-1"></i>View
                                      </span>
                                      <span className="text-muted d-flex align-items-center fs-13 fw-medium disabled">
                                        <i className="ti ti-lock me-1"></i>Download
                                      </span>
                                    </div>
                                  )}
                                </div>

                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="col-12 text-center py-4">
                            <i className="ti ti-award fs-1 text-muted d-block mb-2"></i>
                            <p className="text-muted fs-13 mb-0">No certificates issued yet.</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Certificates Section */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      <StudentModals />
    </>
  );
};

export default StudentDetails;
